import { useReducer } from 'react'
import { weekdays } from '@utils/weekdays'
import { ActionsT, ActionsTypesT, StateT, StoreT, TypePattern, RangePattern } from './types'
import { DateUtil, TIME } from '../../utils/dateUtil'

export default function useBookingDeskStore(): StoreT {
  const [state, dispatch] = useReducer(reducer, initialState)

  return {
    ...state,
    updateBookingDate(date) {
      dispatch({ type: ActionsT.UPDATE_BOOKING_DATE, date })
    },
    clearBookingDate() {
      dispatch({ type: ActionsT.CLEAR_BOOKING_DATE })
    },
    updateRecurredBooking(recurrence) {
      dispatch({ type: ActionsT.UPDATE_RECURRED_BOOKING, recurrence })
    },
    clearRecurredBooking() {
      dispatch({ type: ActionsT.CLEAR_RECURRED_BOOKING })
    },
  }
}

const reducer = (state: StateT, action: ActionsTypesT): StateT => {
  switch (action.type) {
    case ActionsT.UPDATE_BOOKING_DATE: {
      return {
        ...state,
        date: { ...state.date, ...action.date },
      }
    }

    case ActionsT.CLEAR_BOOKING_DATE: {
      return {
        ...state,
        date: { ...initialState.date },
      }
    }

    case ActionsT.UPDATE_RECURRED_BOOKING: {
      return {
        ...state,
        recurrence: { ...state.recurrence, ...action.recurrence },
      }
    }

    case ActionsT.CLEAR_RECURRED_BOOKING: {
      return {
        ...state,
        recurrence: { ...state.recurrence, ...initialState.recurrence },
      }
    }
    default:
      return state
  }
}

export const initialState: StateT = {
  date: {
    fromDate: DateUtil().reset(TIME.SECONDS),
    toDate: null,
  },
  recurrence: {
    typePattern: TypePattern.NEVER,
    rangePattern: RangePattern.ON_DATE,
    rangeDate: DateUtil().add(5, TIME.DAYS),
    daysOfWeek: [weekdays[DateUtil().day()]],
    monthlyType: 'absolute_monthly',
    rangeInterval: 1,
    typeInterval: 1,
    dateLimit: DateUtil(),
    numberLimit: 10,
    // dateLimit, set by meta fetch request
    weekdays,
    userSelectedRangeDate: false,
  },
}
